import { mapErrors } from "@insightfulscience/shared-utils/fn";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import * as Auth from "../services/auth";
import getOperationError from "../apollo/operation-errors";
import routes, { followToReturlUrl } from "../routes";
import { withLoading } from "../nprogress";
import { detectUnexpectedError } from "../services/unexpectedError";

const login = form =>
	Auth.login(form)
		.then(followToReturlUrl({ fallback: routes.myAccount }))
		.catch(mapErrors(getOperationError))
		.catch(detectUnexpectedError({ expected: [404] }));

export default pipe(login, withLoading("login"));
